import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  lowBalanceAlertSettings: null,
}
const lowBalanceAlertSlice = createSlice({
  name: 'lowBalanceAlert',
  initialState,
  reducers: {
    initLowBalanceAlertSettings(state, action) {
      state.lowBalanceAlertSettings = action.payload
    },
  },
})

export const selectLowBalanceAlertSettings = (state) =>
  state.lowBalanceAlert.lowBalanceAlertSettings

export const { initLowBalanceAlertSettings } = lowBalanceAlertSlice.actions

export default lowBalanceAlertSlice.reducer
